var map = {
	"./facebook": [
		556,
		556
	],
	"./facebook.jsx": [
		556,
		556
	],
	"./instagram": [
		4464,
		464
	],
	"./instagram.jsx": [
		4464,
		464
	],
	"./linkedin": [
		5167,
		167
	],
	"./linkedin.jsx": [
		5167,
		167
	],
	"./permutation": [
		3554,
		554
	],
	"./permutation.jsx": [
		3554,
		554
	],
	"./twitter": [
		4718,
		718
	],
	"./twitter.jsx": [
		4718,
		718
	],
	"./xing": [
		5707,
		707
	],
	"./xing.jsx": [
		5707,
		707
	],
	"./youtube": [
		5234,
		234
	],
	"./youtube.jsx": [
		5234,
		234
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2067;
module.exports = webpackAsyncContext;